const routes = [
    {
        path: '/contabilidade',
        component: () => import('../views/Inicio'),
    },
    {
        path: '/contabilidade/inicio',
        component: () => import('../views/Inicio'),
    },
    {
        path: '/contabilidade/sistema/inicio',
        component: () => import('../views/Inicio')
    },
    {
        path: '/contabilidade/empresas/inicio',
        component: () => import('../views/Inicio')
    },
    {
        path: '/contabilidade/integracoes/:hash',
        alias: [
            '/contabilidade/integracoes/index/:hash'
        ],
        component: () => import('../views/Integracoes')
    }
]

export default routes
